module.exports = __webpack_public_path__ + "img/pizzette_done.a3ca7efe.jpg";